export default __webpack_public_path__ + "static/media/eggs-and-waffles-logo.3c276156.svg";